export default class AuthHelper {
    constructor() {
        if($('.woocommerce-form-login').length) {
            let tabId = localStorage.getItem('authTab');

            if(!tabId) {
                tabId = '#tab-login';
                localStorage.setItem('authTab', tabId);
            }

            $(tabId).css({
                'display' : 'block'
            });

            this.setMessageTo(`${tabId} .woocommerce-form`);
            this.markValidationErrors(`${tabId}`);

            $(document).on('click', '.auth-btn-tab', function (e) {
                let id = $(this).attr('href');

                $(id).stop(true, true)
                        .fadeIn(300, function () {
                            localStorage.setItem('authTab', id);
                        })
                        .siblings('.auth-tab')
                        .css({'display' : 'none'});
                e.stopPropagation();
            });
        }

        if($('.lost_reset_password').length) {
            this.setMessageTo('.lost_reset_password');
            this.markValidationErrors('.lost_reset_password');
        }

        if($('.password-reset-email').length) {
            this.setNotificationTo('.password-reset-email');
        }
    }

    setMessageTo(selector) {
        let $messages = $('#content').find('> .woocommerce');

        if($messages.length) {
            $(selector).prepend($messages);
        }
    }

    setNotificationTo(selector) {
        let $messages = $('.woocommerce .woocommerce-message');

        if($messages.length) {
            $(selector).prepend($messages);
        }
    }

    markValidationErrors(selector, rowSelector = 'p') {
        let $selector = $(selector);

        if($selector.find('.woocommerce .woocommerce-error').length) {
            $selector.find('.input-text').closest(rowSelector).addClass('error');
        }
    }
}